<script>
import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
import CategoryCard from "@/components/cards/CategoryCard";
import appConfig from "@/app.config";


export default {
  page: {
    title: "Training",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout, Heading, CategoryCard
  },
  data() {
    return {
      page: {
        title: "Training",
        lastUpdated: '31 Dec 2020 15:00',
        addNewBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false
      },
      categories: [
        {
          name: "Emis",
          additionalProp1: {
            icon: "emis-icon.png",
            link: "/pl-aside-page/emis",
          },
        },
        {
          name: "Docman",
          additionalProp1: {
            icon: "docman-icon.png",
            link: "/pl-aside-page/docman",
          },
        },
        {
          name: "Teams",
          additionalProp1: {
            icon: "teams-icon.svg",
            link: "/pl-aside-page/teams",
          },
        }
      ],
    };
  },
  mounted() {
    // this.$forceUpdate();
  }
};
</script>

<template>
  <Layout>
    <Heading :page="page"></Heading>
    <div class="pl-page-container">
      <h2 class="pl-row-title">
        Applications
      </h2>
      <div class="pl-categories">
        <router-link class="text-dark" v-for="(category, index) in categories" :to="category.additionalProp1.link" :key="index">
          <CategoryCard :icon="category.additionalProp1.icon" :name="category.name" />
        </router-link>
      </div>
    </div>
  </Layout>
</template>
